export const SimuladorBeneficiosFAQ = [
    {
        id: 1,
        title: { rendered: '1. Para que serve este simulador?' },
        content: { rendered: 'Ele mostra quanto você ainda pode investir na sua previdência em 2025 para reduzir o valor do seu Imposto de Renda.' }
    },
    {
        id: 2,
        title: { rendered: '2. Quem pode aproveitar essa economia no Imposto de Renda?' },
        content: { rendered: 'A dedução vale para quem faz a declaração completa do IR e contribui para o INSS.' }
    },
    {
        id: 3,
        title: { rendered: '3. Por que o 13º salário não entra no cálculo?' },
        content: { rendered: 'O 13º tem tributação exclusiva na fonte e não faz parte da base de cálculo do limite de 12% definido pela Receita Federal.' }
    },
    {
        id: 4,
        title: { rendered: '4. O que acontece se eu contribuir mais que o limite de 12%?' },
        content: { rendered: 'O valor que exceder o limite não entra como dedução no Imposto de Renda, mas continua rendendo normalmente dentro do seu plano de previdência.' }
    },
    {
        id: 5,
        title: { rendered: '5. O resultado do simulador é o valor exato do meu imposto?' },
        content: { rendered: 'Não. O simulador é apenas informativo. O cálculo final do Imposto de Renda depende também de outras deduções, como dependentes, despesas médicas e educação.' }
    }
]